<template>
  <div>
    <div  class='blue text-center text--lighten-4 white--text'>
      <h2>Interactive Strip calculator</h2>
    </div>


  <!-- ======================================================== first top left flex ================================ -->
        <v-container fluid class='grey lighten-3' >
          <v-layout row wrap>
            <v-flex xs12 md6  >
              <v-layout wrap >
                 <!-- ----------------------------------------------- left type / material ------------------------------------------ -->
                <v-flex xs12 md6>
                    <!-- <v-card dark tile flat color="error">
                      <v-card-text>#1A</v-card-text>
                    </v-card> -->
                    <v-layout wrap>
                        <v-flex xs6 >
                        <v-select
                          full-width: false
                          :items="types"
                          label="type"
                          solo
                          v-model='selType'
                          @change='setPanel()'
                        ></v-select>
                        </v-flex>
                        <v-flex xs0 md6>

                        </v-flex>  
                        <!-- <v-flex xs12>
                        <v-select
                          full-width: false
                          :items="selmat"
                          item-text="Description"
                          item-value="Reference"                          
                          label="Material"
                          solo
                          v-show=mattog
                        ></v-select>
                        </v-flex>      -->
                        <v-flex xs12>
                            <v-autocomplete
                                v-model="material"
                                :items="selmat"
                                :search-input.sync="onMaterialSearch"
                                hide-no-data
                                clearable
                                item-text="DESCRIPTIO"
                                item-value="DESCRIPTIO"
                                label="Material"
                                placeholder="Start typing to search"
                                return-object
                                @change="onMaterialChange"
                            ></v-autocomplete>
                            </v-flex>                        
                    </v-layout>
     
                </v-flex>

                <!-- --------------------------------------------------------- right  div / strip size--------------------------------------  -->
                <v-flex xs12 md6>
                        <v-flex xs6>
                        <v-select
                          full-width: false
                          :items="div"
                          v-model='seldiv'
                          label="division"
                          solo
                          @change='setSizePanel'
                        ></v-select>
                        </v-flex>
                        <v-flex xs6>
                        <v-select
                          v-show=sizetog
                          full-width: false
                          :items="strsize"
                          v-model='selSize'
                          label="size"
                          solo
                          @blur='setSize()'
                        ></v-select>
                        </v-flex>                        
                </v-flex>
              </v-layout>
            </v-flex>

            <!-- ================================close first flex==================================================== -->
            
            <!-- ========================================== top right flex =============================================== -->
            <v-flex xs12 md6 >
                <v-layout v-show= starttog>
                  <v-flex>
                    <v-layout row>
                      <v-flex xs12 md3>
                        <v-card flat class='grey lighten-3' xs12 md6 >
                        <!--<img class='grey lighten-1 pa-1' rounded src='../../assets/jmpCalc.png' width="220" />-->
                        </v-card>
                      
                      </v-flex>
                      <v-flex xs12 md9>
                        <v-card flat class='grey lighten-3' xs12 md6>

                           <v-card-text>Version 1.0.0</v-card-text>
                          <v-card-text>Compiled By Hans & Sibo</v-card-text>
                          <v-card-text>For internal costings only</v-card-text>
                          <v-card-text>Project Started September 2019</v-card-text>
                            
                        </v-card>  
                      </v-flex>                      
                      
                    </v-layout>
                                      

                  </v-flex>
                    
                </v-layout>
                <v-layout v-show = frmtog>
                    <v-flex xs12 color="red darken-3">
                       <v-card dark tile flat color="red darken-1">
                          <v-card-text>#2A</v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md3 color="red darken-3">
                       <v-card dark tile flat >
                          <v-card-text>#2B</v-card-text>
                        </v-card>                      
                    </v-flex>
                    <v-flex xs12 md9>
                       <v-card dark tile flat color="red darken-5">
                          <v-card-text>#2C</v-card-text>
                        </v-card>
                    </v-flex>                  
                </v-layout>
                <v-layout wrap v-show = strtog>
                    <v-flex xs12>
                        <v-toolbar flat xs12 md6 class="grey lighten-4" height='25px'>
                          <v-btn flat ml-0 width='15px' href="/stripcalc">
                              <!-- <img src='../../assets/JIco.png' width='25px' /> -->JIco
                          </v-btn>
                          <v-spacer></v-spacer> 
                          
                          <v-btn flat ml-0 width='20px'>
                              <img 
                                :src='divico' 
                                :lazy-src='divico'
                                width='25px' 
                              />
                              - Strip
                          </v-btn>
                        </v-toolbar>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-flex xs3 md6 >
                          <v-text-field
                            label="Width"
                            v-model='strWidth'
                          ></v-text-field>
                        </v-flex>     
                        <v-flex xs3 md6 >
                          <v-text-field
                            label="Length"
                            v-model="strLen"
                            @blur='showAlert()'
                          ></v-text-field>
                        </v-flex>  
                        <v-flex xs3 md6 mb-5 >
                          <v-btn rounded @click='calcPrice()'>Calculate</v-btn>
                        </v-flex>                                                                   
                    </v-flex>
                    <v-flex xs12 md9>

                    <v-data-table
                      :headers="headers"
                      :items="calcstripprice"
                      class="elevation-1 table-padding-small text-xs-center table-even-odd"
                      hide-actions
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.type }}</td>
                        <td><v-checkbox class='chkb' :input-value="props.selected" primary hide-details></v-checkbox></td>
                        <td class="text-xs-left">{{ $format.number(props.item.plainstr) }}</td>
                        <td><v-checkbox class='chkb' :input-value="props.selected" primary hide-details></v-checkbox></td>
                        <td class="text-xs-left">{{ $format.number(props.item.holestr) }}</td>
                        <td><v-checkbox class='chkb' :input-value="props.selected" primary hide-details></v-checkbox></td>
                        <td class="text-xs-left">{{ $format.number(props.item.compstr) }}</td>
                        <td class="text-xs-center">{{ props.item.unit }}</td>
                      </template>
                    </v-data-table>  
                    </v-flex>
                </v-layout>
            </v-flex>
            <!-- ============================================ close the second flex ============================================ -->

              
            <v-layout wrap>

              <!-- ========================================= info bar flex============================================================= -->
                <v-flex xs12>
                  <v-card dark tile flat color="grey lighten-3 black--text">
                      <v-layout xs12 height='10%'>
                        <v-flex  xs4>
                          <v-card-text>
                            Material Information
                          </v-card-text>
                        </v-flex>
                        <v-flex xs4>       
                          <v-card-text>
                            {{changedShtMat}} @ {{sheetPricePlain}} / {{stkUnit}}
                          </v-card-text>
                        </v-flex>
                        <v-flex xs4>
                          <v-card-text>
                            <u>Stock Item: </u> {{showSelMat}}  <v-spacer>   </v-spacer>  <u> Instock :  </u> {{selMatInstock}}
                          </v-card-text>                        
                        </v-flex>
                      </v-layout>                                            

                  </v-card>  
                </v-flex>


        <!-- ============================================================table flex ================================================== -->

                <v-flex xs12>
                    <v-data-table
                      :headers="tabheaders"
                      :items="tabstripprice"
                      class="elevation-1 table-padding-small text-xs-center table-even-odd"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{props.item.type}}</td>
                            <td ><v-checkbox class='chkb'  :input-value="props.selected" label="" primary hide-details></v-checkbox></td>
                            <td class="text-xs-left">{{ $format.number(props.item.plainstr) }}</td>
                            <td><v-checkbox class='chkb' :input-value="props.selected" primary hide-details></v-checkbox></td>
                            <td class="text-xs-left">{{ $format.number(props.item.holestr) }}</td>
                            <td><v-checkbox class='chkb' :input-value="props.selected" primary hide-details></v-checkbox></td>
                            <td class="text-xs-left">{{ $format.number(props.item.compstr) }}</td>
                            <td><v-checkbox class='chkb' :input-value="props.selected" primary hide-details></v-checkbox></td>
                            <td class="text-xs-left">{{ $format.number(props.item.psaplstr) }}</td>
                            <td><v-checkbox class='chkb' :input-value="props.selected" primary hide-details></v-checkbox></td>
                            <td class="text-xs-left">{{ $format.number(props.item.psaholestr) }}</td>
                            <td><v-checkbox class='chkb' :input-value="props.selected" primary hide-details></v-checkbox></td>
                            <td class="text-xs-left">{{ $format.number(props.item.psacompstr) }}</td>                                                                        
                            <td class="text-xs-center">{{ props.item.unit }}</td>
                        </template>
                    </v-data-table>  
                </v-flex>
            </v-layout>            
          </v-layout>
      </v-container>
    <!-- ===================================================================================================== -->
 <!-- <td><v-checkbox :input-value="props.selected" primary hide-details></v-checkbox></td> -->
    
  </div>
</template>

<script>
// staticdata
import Constants from '../../util/Constants';
// const math = require('Math');
// calculations
import gsp from '../../util/GetStripPrice';

const rub = ''; // require('../../assets/rubberIco.png');
const spg = ''; // require('../../assets/spongeIco.png');
const igm = ''; // require('../../assets/IGMIco.png');
const jmp = ''; // require('../../assets/JIco.png');


export default {
    data: () => ({
        starttog: true,
        frmtog: false,
        strtog: false,
        sizetog: false,
        calctog: false,
        mattog: false,
        material: [],
        onMaterialSearch: '',
        divico: jmp,
        seldiv: '',
        selType: '',
        selMat: '',
        showSelMat: '',
        changedShtMat: [],
        selMatPrice: 0,
        sheetPricePlain: 0,
        sheetPricePSA: 0,
        selMatInstock: 0,
        selSize: 0,
        strWidth: 0,
        strLen: 0,
        myMat: {},
        // imgsrc: '../../assets/JIco.png',
        types: Constants.STRIP_TYPES,
        div: Constants.STRIP_DIVISION,
        // selmat: sd.materials(),
        selmat: [],
        matInfo: [],
        stkInfo: [],
        stkUnit: '',
        matRef: '',
        matDesc: '',
        matCost: 0,
        psaCost: 0,
        cstPsa: 0,
        matPsa: '',
        matLen: 0,
        shtCst: [],
        strsize: Constants.STRIP_SIZE,
        // mtrstrips: gsp.mtrstrips(),
        // calcstripprice: gsp.calculateStripPrice(),
        calcstripprice: [],
        tabstripprice: [],
        headers: [
            {
                text: 'Strip type',
                align: 'left',
                sortable: true,
                width: '1%',
                value: 'type'
            },
            { text: '', value: '' },
            { text: 'Strip', value: 'Strip' },
            { text: '', value: '' },
            { text: 'Holes', value: 'Holes' },
            { text: '', value: '' },
            { text: 'Complex', value: 'Complex' },
            { text: 'Unit', value: 'Unit' }
        ],
        tabheaders: [
            {
                text: 'Strip Width',
                align: 'Right',
                width: '5%',
                value: 'type'
            },
            { text: '', value: '' },
            { text: 'Strip[m] Plain', value: 'Strip' },
            { text: '', value: '' },
            { text: 'Strip[m] Psa', value: 'Strip' },
            { text: '', value: '' },
            { text: 'Holes[m] Plain', value: 'Strip' },
            { text: '', value: '' },
            { text: 'Holes[m] PSA', value: 'Holes' },
            { text: '', value: '' },
            { text: 'Complex[m] Plain', value: 'Strip' },
            { text: '', value: '' },
            { text: 'Complex[m] PSA', value: 'Holes' }
        ],
        widarr: [
            {
                key: 1,
                type: '6'
            },
            {
                key: 2,
                type: '8'
            },
            {
                key: 3,
                type: '10'
            },
            {
                key: 4,
                type: '12'
            },
            {
                key: 5,
                type: '15'
            },
            {
                key: 6,
                type: '20'
            },
            {
                key: 7,
                type: '25'
            },
            {
                key: 8,
                type: '30'
            },
            {
                key: 9,
                type: '40'
            },
            {
                key: 10,
                type: '50'
            },
            {
                key: 11,
                type: '75'
            },
            {
                key: 12,
                type: '100'
            },
            {
                key: 13,
                type: '150'
            },
            {
                key: 14,
                type: '200'
            },
            {
                key: 15,
                type: '250'
            },
            {
                key: 16,
                type: '300'
            },
            {
                key: 17,
                type: '350'
            },
            {
                key: 18,
                type: '400'
            },
            {
                key: 19,
                type: '450'
            },
            {
                key: 20,
                type: '500'
            }
        ],
        selectedMaterial: [
          { Description: '' },
          { Price: 0 },
          { Thickness: 0 },
          { Width: 0 },
          { Length: 0 },
          { Premium: 0 },
          { Psa: '' },
          { PsaCost: 0 },
          { Division: '' }
        ],
        stripInformation: [
          { Thickness: 0 },
          { Length: 0 },
          { Width: 0 }
        ],
        sectionInfo: [
          { section: 'Die' },
          { wcOh: 0 },
          { asOh: 0 },
          { Labour: 0 },
          { markup: 0 },
          { OHL: 0 }
        ]
    }),
    methods: {
        showAlert() {
          // alert('Hi',mup);
          // console.log(this.strWidth, this.strLen, this.selSize);
          // this.selectedMaterial.Description = this.matInfo.desc;
          // this.selectedMaterial.Price = this.matInfo.cost;
          // this.selectedMaterial.Thickness = this.matInfo.thk;
          // this.selectedMaterial.Width = this.matInfo.wid;
          // this.selectedMaterial.Length = this.matInfo.len;
          // this.selectedMaterial.Psa = this.matPsa;
          // if (this.seldiv === "Sponge" )
          //   {this.selectedMaterial.PsaCost = this.cstPsa}
          //   else
          //   { this.selectedMaterial.PsaCost = 0}
          // this.selectedMaterial.division = this.seldiv;

          // console.log(this.selectedMaterial.PsaCost);

           // console.log(`Mat : ${this.matInfo.desc} : Thickness: ${this.matInfo.thk} ,Width: ${this.matInfo.wid}, Length: ${this.matInfo.len}, PSA:${this.matPsa}, PsaCst ${this.cstPsa}`);
        },
        getMat() {
          // console.clear();
            this.$http
                .post('/jmpcontroller/postname', { myref: this.seldiv })
                .then(response => {
                    this.selmat = response.data;
                    // console.log('Response', response);
                    this.selmat.forEach(e => {
                        // e.CN_COST /= 10000;
                        e.Cost /= 10000;
                        // this.matCost = e.CN_COST;
                    });
                })
                .catch(error => {
                    this.$alert({ type: 'error', title: 'Data call failed', message: `${error}` });
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        async getMatInfo() {
            try {
                const response = await this.$http.post('/jmpcontroller/postCmat', { myref: this.matRef });
                this.matInfo = response.data[0];
                this.matInfo.thk = this.matInfo.THICKNESS;
                this.matInfo.wid = this.matInfo.WIDTH;
                this.matInfo.len = this.matInfo.LENGTH;
                this.matInfo.pre = this.matInfo.PREMIUM;
                this.matInfo.ref = this.matRef;
                this.matInfo.cost = this.matCost;
                this.matInfo.desc = this.matDesc;
                this.showSelMat = this.matDesc;
                this.selMatPrice = this.matInfo.cost;

                delete this.matInfo.THICKNESS;
                delete this.matInfo.WIDTH;
                delete this.matInfo.LENGTH;
                delete this.matInfo.PREMIUM;
            }
            catch (error) {
                this.$alert({ type: 'error', title: 'Data call failed', message: `${error}` });
            }
        },
        async getSelMatInfo() {
            try {
                const response = await this.$http.post('/jmpcontroller/postStkInfo', { myref: this.matRef });
                this.stkInfo = response.data[0];
              // console.log('Instk', this.stkInfo.CN_INSTOCK);
                this.stkInfo.fact = this.stkInfo.CN_FACT.substr(2, 1);
                this.stkInfo.instock = this.stkInfo.CN_INSTOCK / Math.pow(10, this.stkInfo.fact);
                this.stkInfo.desc = this.stkInfo.CN_DESC;
                this.stkInfo.unit = this.stkInfo.CN_FACT.substr(0, 2);
                this.stkUnit = this.stkInfo.unit;
                this.selMatInstock = this.stkInfo.instock;
                delete this.stkInfo.CN_INSTOCK;
                delete this.stkInfo.CN_DESC;
              // console.log('Unit', this.stkUnit);
            }
            catch (err) {
                this.$alert({ type: 'error', title: 'Data call failed', message: `${err}` });
            }
        },
        async getPSA() {
            try {
                const response = await this.$http.post('/jmpcontroller/postPSA', { psaType: this.matPsa });
                this.psaCost = response.data[0];
                this.cstPsa = this.psaCost.CN_COST / 10000;
            // console.log('PSA ' , this.cstPsa);
            }
            catch (error) {
                console.error(error);
            }
        },
        async getOHL() {
            try {
                const response = await this.$http.post('/jmpcontroller/postOHL', { Section: this.sectionInfo.section });
                this.sectionInfo = response.data[0];
                this.sectionInfo.wcOh = this.sectionInfo.WCOVERHEADS;
                this.sectionInfo.asOh = this.sectionInfo.ASOVERHEADS;
                this.sectionInfo.Labour = this.sectionInfo.LABOUR;
                this.sectionInfo.markup = this.sectionInfo.MARKUP;
                this.sectionInfo.OHL = this.sectionInfo.WCOVERHEADS + this.sectionInfo.ASOVERHEADS + this.sectionInfo.LABOUR;
                // console.log('MUP Calc ' , this.sectionInfo.markup/100);
                this.selMatPrice *= 1 + (this.sectionInfo.markup / 100);
            }
            catch (err) {
                this.$alert({ type: 'error', title: 'Data call failed', message: `${err}` });
            }
        },
        setPanel() {
            this.starttog = false;
            if (this.selType === 'Frame') {
                this.frmtog = true;
                this.strtog = false;
                this.mattog = false;
                this.sizetog = false;
            }
            else {
                this.strtog = true;
                this.frmtog = false;
                this.mattog = false;
                this.sizetog = false;
            }
            // console.clear();
        },
        setSizePanel() {
            // alert(this.seldiv);
            if (this.seldiv === 'Sponge') {
                this.sizetog = true;
                this.divico = spg;
                this.sizetog = true;
                this.mattog = true;
                // alert(this.divico);
            }
            else if (this.seldiv === 'Rubber') {
                this.sizetog = true;
                this.divico = rub;
                this.sizetog = false;
                this.mattog = true;
            }
            else if (this.seldiv === 'I.G.M.') {
                this.sizetog = true;
                this.divico = igm;
                this.sizetog = false;
                this.mattog = true;
            }
            else {
                this.sizetog = false;
                this.divico = jmp;
                this.sizetog = false;
                this.mattog = false;
                // alert(this.divico);
            }
            // alert(this.seldiv);
            // console.clear();
            this.getMat(this.seldiv);
            return this.divico;
        },
        calcPrice() {
            // alert(this.strWidth);
            this.selectedMaterial.Description = this.matInfo.desc;
            this.selectedMaterial.Price = this.matInfo.cost;
            this.selectedMaterial.Thickness = this.matInfo.thk;
            this.selectedMaterial.Width = this.matInfo.wid;
            this.selectedMaterial.Length = this.matInfo.len;
            this.selectedMaterial.Premium = this.matInfo.pre;
            this.selectedMaterial.Psa = this.matPsa;

            // debugger;

            this.selMat = this.matInfo.desc;
            // console.log(this.matPsa);
            // console.log(this.selMat);
            // console.log('Premium:', this.matInfo.pre);

            const UseShavings = 10;
            // debugger;
            if (UseShavings === 0) {
                if (this.seldiv === 'Sponge') {
                    this.selectedMaterial.Thickness -= 5;
                }
            }

            if (this.matPsa !== 'NA') {
                this.selectedMaterial.PsaCost = this.cstPsa;
            }
            else {
                this.selectedMaterial.PsaCost = 0;
            }
            this.selectedMaterial.division = this.seldiv;

            this.calctog = !this.calctog;
            this.stripInformation.Thickness = this.seldiv === 'Sponge' ? this.selSize : this.matInfo.thk;
            // Below 1 means use the shaving in the cost, 0 = take the shaving out (2.5 mm each side so 5)

            this.stripInformation.Width = this.strWidth;
            this.stripInformation.Length = this.strLen;
            // console.log('Calc Strip ', this.selSize, this.strWidth, this.strLen);
            // this.mtrstrips = gsp.mtrstrips(this.selSize, this.strWidth);
            // let goCalc = gsp.calculateStripPrice(this.selectedMaterial, this.stripInformation, this.sectionInfo);
            // console.log("Mat_Thickness: " ,this.selectedMaterial.Thickness);
            this.calcstripprice = gsp.calculateStripPrice(this.selectedMaterial, this.stripInformation, this.sectionInfo);
            // this.tabstripprice = gsp.calculateTableStripPrice(this.selectedMaterial, this.stripInformation, this.sectionInfo, 6, 1);
            const list = [];
            this.widarr.forEach(o => {
                list.push(gsp.calculateTableStripPrice(this.selectedMaterial, this.stripInformation, this.sectionInfo, parseInt(o.type, 10), o.key)[0]);
            });
            // console.log("List1 :", list);
            this.tabstripprice = list;
            // console.log("List", this.tabstripprice);
            // this.tabstripprice.push(gsp.calculateTableStripPrice(this.selectedMaterial, this.stripInformation, this.sectionInfo, 8, 2)) ;
            // console.log("Returned:", this.tabstripprice);
            // console.log('Going there!');
            this.changedShtMat = gsp.materialBuilder(this.selectedMaterial.Description, this.stripInformation.Thickness);
            // console.log('Been there!');
            this.shtCst = gsp.calculateSheetPrice(this.selectedMaterial, this.stripInformation, this.sectionInfo, this.stripInformation.Thickness, this.seldiv);
            this.sheetPricePlain = this.shtCst[0].plainstr;
            if (this.seldiv === 'Rubber' || this.seldiv === 'I.G.M.') {
                this.sheetPricePlain = this.shtCst[0].plainstr / (this.selectedMaterial.Length / 1000);
            }
            // console.log('Here', this.sheetPricePlain);
        },
        setSize() {
          // alert(this.selSize);
          // this.selSize = this.strsize;
          // console.log('Strip Thk ', this.selSize);
          // console.log(`Mat : ${this.matInfo.desc} : Thickness: ${this.matInfo.thk} ,Width: ${this.matInfo.wid}, Length: ${this.matInfo.len}, PSA:${this.matPsa} , Str: ${this.selSize}`);
        },
        async onMaterialChange() {
            // this.matRef = this.material.CN_REF;
            this.matRef = this.material.REFERENCE;
            // this.matDesc = this.material.CN_DESC;
            this.matDesc = this.material.DESCRIPTIO;
            // this.matCost = this.material.CN_COST;
            this.matCost = this.material.Cost;
            this.matPsa = this.material.PSAFLAG;
            // this.PSARef = this.material.REFERENCE;
            this.sectionInfo.section = 'Die';
            // console.log("Trial", this.matDesc, this.matRef, this.matCost, this.selmat);
            // debugger;
            await this.getMatInfo(this.matRef);
            // get instock info and other info if needed
            await this.getSelMatInfo(this.matRef);
            // console.log('Here is ', this.matPsa);
            // console.log('Instk2', this.stkInfo.instock);
            await this.getPSA();
            await this.getOHL();
            // console.log(`Mat : ${this.matInfo.desc} : Thickness: ${this.matInfo.thk} ,Width: ${this.matInfo.wid}, Length: ${this.matInfo.len}, Premium:${this.matInfo.pre}  PSA:${this.matPsa}`);
        },
        setDivision() {
            // alert(this.seldiv);
            // console.log(this.seldiv);
            if (this.seldiv === 'Rubber') {
                this.divico = rub;
                this.showSize = false;
            }
            else if (this.seldiv === 'Sponge') {
                this.divico = spg;
                this.showSize = true;
            }
            else if (this.seldivs === 'IGM') {
                this.divico = igm;
                this.showSize = false;
            }
            else {
                this.divico = jmp;
            }
            // alert('end of setDivision');
            // alert(this.divico);
            // return this.divico;
          // src='../../assets/JIco.png'
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/PriceList/stripcalc.vue